var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title",class:{'section-title--subsection': _vm.subsection}},[_c('h2',{staticClass:"section-title__title"},[_vm._t("default")],2),_c('div',{staticClass:"section-title__divider"})])}
var staticRenderFns = []

export { render, staticRenderFns }